export default __webpack_public_path__ + "static/media/modal-dots.bb32bf97.svg";